import { render, staticRenderFns } from "./SvgComment.vue?vue&type=template&id=15748df4&"
import script from "./SvgComment.vue?vue&type=script&lang=js&"
export * from "./SvgComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports